/**
 * Login Page
 *
 * Redirects immediately to auth.tyaus.com for authentication via SSO.
 * Local email/password login is not supported — all users authenticate
 * through the centralised Auth Centre.
 */

import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuthStore } from '../stores/auth';
import { startSsoLogin } from '../utils/ssoAuth';

export default function LoginPage() {
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo') || '/dashboard';
  const { isAuthenticated } = useAuthStore();

  useEffect(() => {
    if (!isAuthenticated) {
      startSsoLogin(returnTo);
    }
  }, [isAuthenticated, returnTo]);

  return (
    <div className="min-h-screen bg-surface-950 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-8 h-8 animate-spin text-green-500" />
        <p className="text-surface-400 text-sm">Redirecting to auth.tyaus.com…</p>
      </div>
    </div>
  );
}
